import changeProfileDialog from './ChangeProfileDialog.html';

/*****************************************************************************************
 * Dialog allows update of the user profile.
 *****************************************************************************************/
/* @ngInject */ export function ChangeProfileDialogService($uibModal) {
  this.show = function () {
    var dialog = $uibModal.open({
      animation: true,
      template: changeProfileDialog,
      controller: controller,
      size: 'md',
      backdrop: 'static',
      windowClass: 'menu-modal-popup'
    });

    return dialog.result;
  };
}

/***************************************************************************
 * Controller
 ***************************************************************************/
/* @ngInject */ function controller(
  $rootScope,
  $scope,
  $uibModalInstance,
  CommonSvc,
  Alert
) {
  /*-------------------*/
  /* Load user profile */
  /*-------------------*/
  CommonSvc.getUserProfile().then(function (result) {
    $scope.user = result.data;
    delete $scope.user.id;
  });

  /***************************************************************************
   * cancel */
  /**
   * Dismiss the modal
   ***************************************************************************/
  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  /***************************************************************************
   * ok */
  /**
   * Saves the user's input and refreshes the page.
   ***************************************************************************/
  $scope.ok = function () {
    CommonSvc.updateProfile($scope.user).then(function () {
      Alert.success('Your profile has been updated!', 'Profile Updated');
      $uibModalInstance.close('Success!');
    });
  };
}
